import BrandingForm from './BrandingForm.component';

export default BrandingForm;
